import { ADD_TERMS_AND_CONDITION, DELETE_TERMS_AND_CONDITION, GET_ALL_TERMS_AND_CONDITION } from '../config/urlConfig'
import axios from 'axios';

// Function for add TERMS AND CONDITION
export async function handleAddTermsAndConditionApi(term, token) {
    try {
    
        let data ={
            term : term
        }
      let response = await axios.post(ADD_TERMS_AND_CONDITION,data , {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);
  
        return error.response.data;
      }
      console.log(error.message);
    }
}

// Function for fetch TERMS AND CONDITION
export async function getAllTermsAndConditionsApi(token) {
    try {
    
      let response = await axios.get(GET_ALL_TERMS_AND_CONDITION, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);
  
        return error.response.data;
      }
      console.log(error.message);
    }
  }

  // Function for delete TERMS AND CONDITION
export async function handleDeleteTermsAndConditionsApi(id, token) {
    try {
      

      let response = await axios.delete(`${DELETE_TERMS_AND_CONDITION}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);
  
        return error.response.data;
      }
      console.log(error.message);
    }
  }